import React from 'react'
import { Outlet, Navigate } from 'react-router-dom'
import { getToken } from 'utils/cookies'

export default function PrivateRoute() {
  return getToken() ? <Outlet /> : <Navigate to='/login' />
}
